import { useState } from 'react'

import {
  ProtocoloAtivoAlunoDto,
  ValoresRescisaoDto
} from 'src/servicos/api/rescisao'
import { createContainer } from 'unstated-next'

import {
  DadosSolicitacaoWizard,
  RescisaoContainerEstado,
  RescisaoContainerProps
} from './tipos'

const useRescisao = (initialState?: RescisaoContainerProps) => {
  const [estado, definirEstado] = useState<RescisaoContainerEstado>({
    passo: 1,
    ...initialState
  })

  const definirPasso = (passo: number) =>
    definirEstado(old => ({ ...old, passo }))

  const definirProtocolo = (protocolo: ProtocoloAtivoAlunoDto) =>
    definirEstado(old => ({ ...old, protocolo }))

  const definirValores = (valores: ValoresRescisaoDto) =>
    definirEstado(old => ({ ...old, valores }))

  const definirDadosSolicitacao = (dadosSolicitacao: DadosSolicitacaoWizard) =>
    definirEstado(old => ({
      ...old,
      dadosSolicitacao: { ...old.dadosSolicitacao, ...dadosSolicitacao }
    }))

  return {
    ...estado,
    definirPasso,
    definirProtocolo,
    definirValores,
    definirDadosSolicitacao
  }
}

export default createContainer(useRescisao)
